import { FC, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useAuth, Logo } from '@isocel/front-common';
import { Row, Col } from 'antd';

import { AppUser } from '../../queries/api/types';
import './Home.less';

const Home: FC = () => {
    const { user } = useAuth();
    const appUser = user as AppUser;
    const history = useHistory();

    useEffect(() => {
        if (appUser?.needPasswordChange) {
            history.push('/change-password');
        }
    }, [appUser, history]);

    if (appUser?.needPasswordChange) {
        history.push('/change-password');
        return null;
    }
    return (
        <Row justify="center">
            <Col span={16}>
                <div className="mainpage-container">
                    <div>
                        Bonjour {user?.firstName} {user?.lastName}.
                    </div>
                    <div>Bienvenue sur l&lsquo;espace Emballage.</div>
                    <div className="items-center mainpage-container-logo">
                        <Logo />
                    </div>
                    <div className="mt-16 bg-orange text-black font-20 text-uppercase rounded-sm py-8 px-16 leading-4 font-bold space-x-2">
                        Emballage
                    </div>
                </div>
            </Col>
        </Row>
    );
};

export default Home;
